/* Radius Puro — Prototyp-Interaktionen. Ohne Abhängigkeiten. */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  // Erst wenn dieses Skript laeuft, duerfen Reveal-Elemente verborgen sein.
  document.documentElement.classList.add("rp-js");

  var euro = function (cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  };

  /* ---------------------------------------------------------------- *
   * Warenkorb — Platzhalter. read()/write() gegen die echte Cart-API
   * tauschen (Shopify /cart.js), alles andere liest nur von hier.
   * ---------------------------------------------------------------- */

  // Der Warenkorb des Prototyps (localStorage) ist hier bewusst entfernt.
  // Im Shop fuehrt Shopify den Warenkorb; die Platzhalterlogik wuerde Zaehler,
  // Summen und Positionen ueberschreiben.

  /* ---------------------------------------------------------------- *
   * Overlay-Steuerung für beide Drawer
   * ---------------------------------------------------------------- */

  var scrim = null;

  function makeDrawer(selector, openAttr, closeAttr) {
    var el = document.querySelector(selector);
    if (!el) return null;
    var opener = null;

    var api = {
      el: el,
      toggle: function (open) {
        el.setAttribute("data-open", String(open));
        el.setAttribute("aria-hidden", String(!open));
        if (scrim) scrim.setAttribute("data-open", String(open));
        document.body.style.overflow = open ? "hidden" : "";

        if (open) {
          opener = document.activeElement;
          var first = el.querySelector("button, a, input");
          if (first) first.focus();
        } else if (opener) {
          opener.focus();
        }
      },
      isOpen: function () { return el.getAttribute("data-open") === "true"; }
    };

    document.querySelectorAll(openAttr).forEach(function (b) {
      b.addEventListener("click", function () { api.toggle(true); });
    });
    el.querySelectorAll(closeAttr).forEach(function (b) {
      b.addEventListener("click", function () { api.toggle(false); });
    });
    return api;
  }

  var cartDrawer = null;
  var navDrawer = null;
  var panes = { list: [], stack: ["root"] };

  function paintPanes() {
    var current = panes.stack[panes.stack.length - 1];
    panes.list.forEach(function (p) {
      var id = p.dataset.pane;
      if (id === current) p.dataset.state = "current";
      else if (panes.stack.indexOf(id) > -1) p.dataset.state = "behind";
      else p.dataset.state = "away";
    });
  }

  function initNav() {
    if (!navDrawer) return;
    panes.list = Array.prototype.slice.call(navDrawer.el.querySelectorAll("[data-pane]"));
    paintPanes();

    navDrawer.el.querySelectorAll("[data-pane-to]").forEach(function (b) {
      b.addEventListener("click", function () {
        panes.stack.push(b.dataset.paneTo);
        paintPanes();
        var pane = navDrawer.el.querySelector('[data-pane="' + b.dataset.paneTo + '"]');
        var first = pane && pane.querySelector("button, a");
        if (first) first.focus();
      });
    });

    navDrawer.el.querySelectorAll("[data-pane-back]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (panes.stack.length < 2) return;
        panes.stack.pop();
        paintPanes();
      });
    });
  }

  /* ---------------------------------------------------------------- *
   * Megamenü — Hover macht CSS, hier kommen Klick, Tastatur und
   * Aussenklick dazu, damit es auf Touch und mit Screenreader geht.
   * ---------------------------------------------------------------- */

  function initMega() {
    var items = Array.prototype.slice.call(document.querySelectorAll(".rp-menuitem"));
    if (!items.length) return;

    function closeAll() {
      items.forEach(function (item) {
        item.removeAttribute("data-open");
        var t = item.querySelector(".rp-trigger");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector(".rp-trigger");
      if (!trigger || !item.querySelector(".rp-mega")) return;
      trigger.setAttribute("aria-expanded", "false");

      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var was = item.getAttribute("data-open") === "true";
        closeAll();
        if (!was) {
          item.setAttribute("data-open", "true");
          trigger.setAttribute("aria-expanded", "true");
        }
      });

      item.addEventListener("mouseleave", function () {
        item.removeAttribute("data-open");
        trigger.setAttribute("aria-expanded", "false");
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest(".rp-menuitem")) closeAll();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var open = document.querySelector('.rp-menuitem[data-open="true"]');
      if (!open) return;
      closeAll();
      var t = open.querySelector(".rp-trigger");
      if (t) t.focus();
    });
  }

  /* ---------------------------------------------------------------- *
   * Produktseite: Galerie, Menge, In den Warenkorb
   * ---------------------------------------------------------------- */

  var galerie = {
    wurzel: null, track: null, slides: [], thumbs: [],
    index: 0, farbe: "",

    sichtbar: function () {
      return galerie.slides.filter(function (s) { return !s.hidden; });
    },

    zeigeIndex: function (i, sanft) {
      var liste = galerie.sichtbar();
      if (!liste.length) return;
      galerie.index = Math.max(0, Math.min(i, liste.length - 1));
      var ziel = liste[galerie.index];
      galerie.track.scrollTo({
        left: ziel.offsetLeft - galerie.track.offsetLeft,
        behavior: sanft === false ? "auto" : "smooth"
      });
      galerie.markiere();
    },

    // Beim Wischen bestimmt die Scrollposition den Index, nicht umgekehrt.
    ausScroll: function () {
      var liste = galerie.sichtbar();
      if (!liste.length) return;
      var mitte = galerie.track.scrollLeft + galerie.track.clientWidth / 2;
      var beste = 0, abstand = Infinity;
      liste.forEach(function (s, i) {
        var m = s.offsetLeft - galerie.track.offsetLeft + s.clientWidth / 2;
        if (Math.abs(m - mitte) < abstand) { abstand = Math.abs(m - mitte); beste = i; }
      });
      galerie.index = beste;
      galerie.markiere();
    },

    markiere: function () {
      var liste = galerie.sichtbar();
      var aktiv = liste[galerie.index];

      galerie.thumbs.forEach(function (b) {
        var s = galerie.slides[Number(b.dataset.thumb)];
        b.classList.toggle("is-active", s === aktiv);
      });

      var zaehler = galerie.wurzel.querySelector("[data-counter]");
      var gesamt = galerie.wurzel.querySelector("[data-counter-total]");
      if (zaehler) zaehler.textContent = galerie.index + 1;
      if (gesamt) gesamt.textContent = liste.length;

      var prev = galerie.wurzel.querySelector("[data-prev]");
      var next = galerie.wurzel.querySelector("[data-next]");
      if (prev) prev.disabled = galerie.index === 0;
      if (next) next.disabled = galerie.index === liste.length - 1;
    },

    // Farbwechsel: fremdfarbige Bilder ausblenden und auf das Bild der
    // gewaehlten Farbe springen.
    setzeFarbe: function (farbe, springen) {
      galerie.farbe = farbe || "";
      var vorher = galerie.sichtbar()[galerie.index] || null;
      var ersterTreffer = -1;

      galerie.slides.forEach(function (s, i) {
        var f = s.dataset.farbe || "";
        var passt = !f || !galerie.farbe || f === galerie.farbe;
        s.hidden = !passt;
        if (f && f === galerie.farbe && ersterTreffer < 0) ersterTreffer = i;
      });
      galerie.thumbs.forEach(function (b) {
        b.hidden = galerie.slides[Number(b.dataset.thumb)].hidden;
      });

      var liste = galerie.sichtbar();

      // Beim ersten Aufbau bleibt das Hauptbild stehen; gesprungen wird nur bei
      // einem echten Farbwechsel — oder wenn das aktuelle Bild wegfiltert wird.
      if (springen === false && vorher && !vorher.hidden) {
        galerie.index = liste.indexOf(vorher);
        galerie.markiere();
      } else {
        var ziel = ersterTreffer >= 0 ? liste.indexOf(galerie.slides[ersterTreffer]) : 0;
        galerie.zeigeIndex(ziel < 0 ? 0 : ziel, springen !== false);
      }

      return ersterTreffer >= 0 ? galerie.slides[ersterTreffer].querySelector("img").src : null;
    },

    init: function () {
      galerie.wurzel = document.querySelector("[data-gallery]");
      if (!galerie.wurzel) return;

      galerie.track = galerie.wurzel.querySelector("[data-track]");
      galerie.slides = Array.prototype.slice.call(galerie.wurzel.querySelectorAll(".rp-slide"));
      galerie.thumbs = Array.prototype.slice.call(galerie.wurzel.querySelectorAll("[data-thumb]"));

      galerie.thumbs.forEach(function (b) {
        b.addEventListener("click", function () {
          var s = galerie.slides[Number(b.dataset.thumb)];
          galerie.zeigeIndex(galerie.sichtbar().indexOf(s));
        });
      });

      var prev = galerie.wurzel.querySelector("[data-prev]");
      var next = galerie.wurzel.querySelector("[data-next]");
      if (prev) prev.addEventListener("click", function () { galerie.zeigeIndex(galerie.index - 1); });
      if (next) next.addEventListener("click", function () { galerie.zeigeIndex(galerie.index + 1); });

      var timer;
      galerie.track.addEventListener("scroll", function () {
        clearTimeout(timer);
        timer = setTimeout(galerie.ausScroll, 90);
      });

      galerie.track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); galerie.zeigeIndex(galerie.index - 1); }
        if (e.key === "ArrowRight") { e.preventDefault(); galerie.zeigeIndex(galerie.index + 1); }
      });

      galerie.slides.forEach(function (s) {
        s.addEventListener("click", function () { lightbox.oeffne(galerie.index); });
      });
      var zoom = galerie.wurzel.querySelector("[data-zoom]");
      if (zoom) zoom.addEventListener("click", function (e) {
        e.stopPropagation();
        lightbox.oeffne(galerie.index);
      });

      galerie.markiere();
    }
  };

  /* ---------------------------------------------------------------- *
   * Lightbox — dieselbe Wisch-Mechanik, nur gross, plus Zoom auf Klick
   * ---------------------------------------------------------------- */

  var lightbox = {
    el: null, track: null, index: 0, oeffner: null,

    baue: function () {
      lightbox.track.innerHTML = galerie.sichtbar().map(function (s) {
        // Video-Folien (Produkt-Videos, 30.07.2026): auch in der Lightbox
        // abspielbar rendern — vorher brach s.querySelector("img").src hier
        // mit einem Fehler ab und der Zoom blieb tot.
        var vid = s.querySelector("video");
        if (vid) {
          var quelle = vid.currentSrc || "";
          if (!quelle) {
            var q = vid.querySelector("source");
            if (q) quelle = q.src;
          }
          var vLabel = s.querySelector(".rp-ki-label") ? '<span class="rp-ki-label">KI-generiert</span>' : "";
          return '<div class="rp-lightbox__slide rp-lightbox__slide--video">' +
                 '<video src="' + quelle + '" controls playsinline muted loop preload="metadata"></video>' + vLabel + '</div>';
        }
        var im = s.querySelector("img");
        if (!im) return '<div class="rp-lightbox__slide"></div>';
        // KI-Kennzeichnung (Art. 50 Abs. 4 KI-VO) auch in der Lightbox zeigen.
        var kiLabel = (im.alt || "").indexOf("KI-generiert") >= 0 ? '<span class="rp-ki-label">KI-generiert</span>' : "";
        return '<div class="rp-lightbox__slide"><img src="' + im.src + '" alt="' + (im.alt || "") + '">' + kiLabel + '</div>';
      }).join("");

      lightbox.track.querySelectorAll("img").forEach(function (im) {
        im.addEventListener("click", function (e) {
          e.stopPropagation();
          var an = im.dataset.zoomed === "true";
          lightbox.track.querySelectorAll("img").forEach(function (x) { x.dataset.zoomed = "false"; });
          im.dataset.zoomed = an ? "false" : "true";
          // Bei Zoom das Wischen abschalten, sonst kaempfen Scroll und Zoom.
          lightbox.track.dataset.zoomed = an ? "false" : "true";
        });
      });

      var gesamt = lightbox.el.querySelector("[data-lb-total]");
      if (gesamt) gesamt.textContent = galerie.sichtbar().length;
    },

    zeige: function (i, sanft) {
      var slides = lightbox.track.querySelectorAll(".rp-lightbox__slide");
      if (!slides.length) return;
      lightbox.index = Math.max(0, Math.min(i, slides.length - 1));
      lightbox.track.scrollTo({
        left: slides[lightbox.index].offsetLeft,
        behavior: sanft === false ? "auto" : "smooth"
      });
      var z = lightbox.el.querySelector("[data-lb-counter]");
      if (z) z.textContent = lightbox.index + 1;
    },

    oeffne: function (i) {
      if (!lightbox.el) return;
      lightbox.oeffner = document.activeElement;
      lightbox.baue();
      lightbox.el.hidden = false;
      lightbox.el.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      lightbox.zeige(i, false);
      var schliessen = lightbox.el.querySelector("[data-lb-close]");
      if (schliessen) schliessen.focus();
    },

    schliesse: function () {
      if (!lightbox.el || lightbox.el.hidden) return;
      lightbox.el.hidden = true;
      lightbox.el.setAttribute("aria-hidden", "true");
      lightbox.track.dataset.zoomed = "false";
      document.body.style.overflow = "";
      galerie.zeigeIndex(lightbox.index, false);
      if (lightbox.oeffner) lightbox.oeffner.focus();
    },

    init: function () {
      lightbox.el = document.querySelector("[data-lightbox]");
      if (!lightbox.el) return;
      lightbox.track = lightbox.el.querySelector("[data-lb-track]");

      lightbox.el.querySelector("[data-lb-close]").addEventListener("click", lightbox.schliesse);
      lightbox.el.querySelector("[data-lb-prev]").addEventListener("click", function () { lightbox.zeige(lightbox.index - 1); });
      lightbox.el.querySelector("[data-lb-next]").addEventListener("click", function () { lightbox.zeige(lightbox.index + 1); });

      lightbox.el.addEventListener("click", function (e) {
        if (e.target === lightbox.el || e.target.classList.contains("rp-lightbox__slide")) lightbox.schliesse();
      });

      var timer;
      lightbox.track.addEventListener("scroll", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var slides = lightbox.track.querySelectorAll(".rp-lightbox__slide");
          var mitte = lightbox.track.scrollLeft + lightbox.track.clientWidth / 2;
          slides.forEach(function (s, i) {
            if (Math.abs(s.offsetLeft + s.clientWidth / 2 - mitte) < s.clientWidth / 2) {
              lightbox.index = i;
              var z = lightbox.el.querySelector("[data-lb-counter]");
              if (z) z.textContent = i + 1;
            }
          });
        }, 90);
      });

      document.addEventListener("keydown", function (e) {
        if (lightbox.el.hidden) return;
        if (e.key === "Escape") lightbox.schliesse();
        if (e.key === "ArrowLeft") lightbox.zeige(lightbox.index - 1);
        if (e.key === "ArrowRight") lightbox.zeige(lightbox.index + 1);
      });
    }
  };

  /* ---------------------------------------------------------------- *
   * Produktseite: Varianten, Menge, In den Warenkorb
   * ---------------------------------------------------------------- */

  /* ---------------------------------------------------------------- *
   * Montage-Umschalter. Eigenstaendig, weil die Rubrik auch auf
   * montage.html steht — dort gibt es kein Kaufformular, und die Logik
   * haette an dessen Fehlen nicht scheitern duerfen.
   * ---------------------------------------------------------------- */

  var montage = {
    zeigeWeg: function (id) {
      document.querySelectorAll("[data-weg]").forEach(function (el) {
        el.dataset.aktiv = String(el.dataset.weg === id);
      });
      document.querySelectorAll("[data-weg-pill]").forEach(function (b) {
        b.classList.toggle("is-active", b.dataset.wegPill === id);
      });
    },

    init: function () {
      var pills = document.querySelectorAll("[data-weg-pill]");
      if (!pills.length) return;
      pills.forEach(function (b) {
        b.addEventListener("click", function () { montage.zeigeWeg(b.dataset.wegPill); });
      });
    }
  };

  function initProduct() {
    galerie.init();
    lightbox.init();

    var form = document.querySelector("[data-add-form]");
    if (!form) return;

    var out = form.querySelector("[data-qty-output]");
    form.querySelectorAll("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        out.textContent = Math.max(1, Number(out.textContent) + Number(b.dataset.qtyStep));
      });
    });

    var priceEl = form.querySelector("[data-price-out]");
    var base = Number(form.dataset.productPrice);
    var warenkorbBild = form.dataset.productImage;

    function currentVariant() {
      var parts = [];
      form.querySelectorAll("input[type=radio]:checked").forEach(function (r) { parts.push(r.value); });
      return parts.join(" / ") || "Standard";
    }

    function currentPrice() {
      var mount = form.querySelector('[data-option-rolle="montage"] input:checked, input[data-option-rolle="montage"]:checked, input[name=montage]:checked');
      var extra = mount && mount.dataset.extra ? Number(mount.dataset.extra) : 0;
      return base + extra;
    }

    function syncPrice() {
      if (priceEl) priceEl.textContent = euro(currentPrice());
    }

    // Das Partnerlogo gehoert zur Klebevariante, nicht zum Bohren.
    var partner = document.querySelector("[data-partner]");
    function syncPartner() {
      if (!partner) return;
      var montage = form.querySelector('[data-option-rolle="montage"] input:checked, input[data-option-rolle="montage"]:checked, input[name=montage]:checked');
      partner.dataset.aktiv = String(!!(montage && montage.value === "Kleben"));
    }

    // Die Rubrik folgt der Variantenwahl. Umgekehrt aendern ihre Pills die
    // Auswahl NICHT — sonst springt beim blossen Nachlesen der Preis.
    function syncWeg() {
      var gewaehlt = form.querySelector('[data-option-rolle="montage"] input:checked, input[data-option-rolle="montage"]:checked, input[name=montage]:checked');
      if (gewaehlt) montage.zeigeWeg(gewaehlt.value === "Kleben" ? "kleben" : "bohren");
    }

    function syncFarbe(springen) {
      var farbe = form.querySelector('[data-option-rolle="farbe"] input:checked, input[data-option-rolle="farbe"]:checked, input[name=farbe]:checked');
      if (!farbe) return;
      var treffer = galerie.setzeFarbe(farbe.value, springen);
      if (treffer) warenkorbBild = treffer;
    }

    form.querySelectorAll("input[type=radio]").forEach(function (r) {
      r.addEventListener("change", function () {
        syncPrice();
        if (r.name === "montage" || r.closest('[data-option-rolle="montage"]')) { syncPartner(); syncWeg(); }
        if (r.name === "farbe" || r.closest('[data-option-rolle="farbe"]')) syncFarbe(true);
      });
    });
    syncPrice();
    syncPartner();

    // Horizon ersetzt beim Variantenwechsel Teile des DOM. Danach zeigen
    // Logo und Montageweg wieder den Serverzustand — der stimmt zwar, aber
    // die Auswahl kann inzwischen weitergeklickt worden sein. Deshalb nach
    // jeder Ersetzung erneut abgleichen.
    var beobachter = new MutationObserver(function () {
      syncPartner();
      syncWeg();
    });
    beobachter.observe(form, { childList: true, subtree: true, attributes: true,
                               attributeFilter: ["checked", "data-current-checked"] });
    syncWeg();
    syncFarbe(false);

    form.addEventListener("submit", function (e) {
      // kein preventDefault: das Shopify-Formular muss durchlaufen
        // Warenkorb: uebernimmt das Theme
      if (cartDrawer) cartDrawer.toggle(true);
    });
  }

  /* ---------------------------------------------------------------- *
   * Hero-Slideshow — dieselbe Scroll-Snap-Mechanik wie die Galerie,
   * dazu Punkte und ein Autoplay, das bei Interaktion pausiert.
   * ---------------------------------------------------------------- */

  function initHero() {
    var wurzel = document.querySelector("[data-hero]");
    if (!wurzel) return;

    var track = wurzel.querySelector("[data-hero-track]");
    var slides = Array.prototype.slice.call(wurzel.querySelectorAll(".rp-heroslide"));
    var punkte = Array.prototype.slice.call(wurzel.querySelectorAll("[data-hero-dot]"));
    if (!track || slides.length < 2) return;

    var index = 0;
    var laeuft = null;

    function markiere() {
      punkte.forEach(function (b, i) { b.classList.toggle("is-active", i === index); });
      // Nur die sichtbare Folie ist per Tab erreichbar.
      slides.forEach(function (s, i) {
        s.querySelectorAll("a, button").forEach(function (el) {
          if (i === index) el.removeAttribute("tabindex");
          else el.setAttribute("tabindex", "-1");
        });
      });
    }

    function zeige(i, sanft) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[index].offsetLeft - track.offsetLeft,
        behavior: sanft === false ? "auto" : "smooth"
      });
      markiere();
    }

    var timer;
    track.addEventListener("scroll", function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var mitte = track.scrollLeft + track.clientWidth / 2;
        slides.forEach(function (s, i) {
          var m = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
          if (Math.abs(m - mitte) < s.clientWidth / 2) { index = i; markiere(); }
        });
      }, 90);
    });

    wurzel.querySelector("[data-hero-prev]").addEventListener("click", function () { stopp(); zeige(index - 1); });
    wurzel.querySelector("[data-hero-next]").addEventListener("click", function () { stopp(); zeige(index + 1); });
    punkte.forEach(function (b, i) {
      b.addEventListener("click", function () { stopp(); zeige(i); });
    });

    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); stopp(); zeige(index - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); stopp(); zeige(index + 1); }
    });

    function start() {
      if (laeuft) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      laeuft = setInterval(function () { zeige(index + 1); }, 7000);
    }
    function stopp() {
      clearInterval(laeuft);
      laeuft = null;
    }

    // Kein Stopp bei blossem Mouseover: der Hero fuellt den oberen Bereich,
    // dort steht der Zeiger fast immer — die Show liefe dann nie an.
    // Angehalten wird nur, wenn jemand wirklich uebernimmt: Tastaturfokus,
    // Beruehrung oder ein Klick auf Pfeile und Punkte (siehe stopp() oben).
    wurzel.addEventListener("focusin", stopp);
    wurzel.addEventListener("touchstart", stopp, { passive: true });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopp(); else start();
    });

    markiere();
    start();
  }

  /* ---------------------------------------------------------------- *
   * Filter-Pills auf der Kollektionsseite
   * ---------------------------------------------------------------- */

  function initFilters() {
    var pills = document.querySelectorAll("[data-filter]");
    if (!pills.length) return;
    var cards = document.querySelectorAll("[data-cat]");
    var counter = document.querySelector("[data-filter-count]");

    function anwenden(want) {
      pills.forEach(function (p) { p.classList.toggle("is-active", p.dataset.filter === want); });

      var shown = 0;
      cards.forEach(function (card) {
        // "kleben" filtert nach Montageart, alle uebrigen nach Kategorie.
        var hit = want === "alle"
          ? true
          : want === "kleben" ? card.dataset.kleben === "1" : card.dataset.cat === want;
        card.hidden = !hit;
        if (hit) shown++;
      });
      if (counter) counter.textContent = shown;
    }

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () { anwenden(pill.dataset.filter); });
    });

    // Deeplink von der Startseite: badezimmer.html#ohne-bohren
    if (location.hash === "#ohne-bohren") anwenden("kleben");
  }

  /* ---------------------------------------------------------------- *
   * Reveals
   * ---------------------------------------------------------------- */

  function initReveals() {
    var targets = document.querySelectorAll(".rv");
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("rv--in"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("rv--in");
        io.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- *
   * Karten-Slider (Kollektion)
   *
   * Jede Karte mit mehreren Bildern traegt [data-cardslider]. Das Wischen
   * laeuft nativ ueber scroll-snap; hier werden nur die Punkte gespiegelt und
   * Punkt-/Pfeilklicks in Scrollbewegungen uebersetzt. Wird mehrfach sicher
   * aufgerufen (Theme-Editor) — bereits initialisierte Slider ueberspringt es.
   * ---------------------------------------------------------------- */

  function initCardSliders() {
    var slider = Array.prototype.slice.call(
      document.querySelectorAll("[data-cardslider]")
    );

    slider.forEach(function (wurzel) {
      if (wurzel.dataset.cardsliderReady === "1") return;
      wurzel.dataset.cardsliderReady = "1";

      var track = wurzel.querySelector("[data-cardslider-track]");
      if (!track) return;
      var slides = Array.prototype.slice.call(
        track.querySelectorAll(".rp-cardslider__slide")
      );
      var dots = Array.prototype.slice.call(
        wurzel.querySelectorAll("[data-cardslider-dot]")
      );
      var prev = wurzel.querySelector("[data-cardslider-prev]");
      var next = wurzel.querySelector("[data-cardslider-next]");
      if (slides.length < 2) return;

      var index = 0;

      function markiere(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        dots.forEach(function (d, di) {
          if (di === index) d.setAttribute("aria-current", "true");
          else d.removeAttribute("aria-current");
        });
        // Nur das sichtbare Bild ist per Tab erreichbar.
        slides.forEach(function (s, si) {
          s.setAttribute("tabindex", si === index ? "0" : "-1");
        });
        if (prev) prev.hidden = index === 0;
        if (next) next.hidden = index === slides.length - 1;
      }

      function zeige(i, glatt) {
        var ziel = Math.max(0, Math.min(i, slides.length - 1));
        // Track-Breite mal Index statt offsetLeft: offsetLeft ist relativ zum
        // positionierten Vorfahren (dem Slider) und liefert nicht die
        // Scrollposition. clientWidth ist die Breite einer Folie (flex 100%).
        track.scrollTo({
          left: ziel * track.clientWidth,
          behavior: glatt === false ? "auto" : "smooth"
        });
      }

      dots.forEach(function (d, di) {
        d.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          zeige(di);
        });
      });

      if (prev) {
        prev.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          zeige(index - 1);
        });
      }
      if (next) {
        next.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          zeige(index + 1);
        });
      }

      // Beim Wischen die Punkte nachziehen. Gedrosselt ueber rAF, damit der
      // Scroll-Handler die Bildlaufleistung nicht ausbremst.
      var wartet = false;
      track.addEventListener("scroll", function () {
        if (wartet) return;
        wartet = true;
        window.requestAnimationFrame(function () {
          wartet = false;
          var breite = slides[0].offsetWidth || 1;
          markiere(Math.round(track.scrollLeft / breite));
        });
      });

      markiere(0);
    });
  }

  /* ---------------------------------------------------------------- *
   * Start
   * ---------------------------------------------------------------- */

  function boot() {
    scrim = document.querySelector("[data-scrim]");

    cartDrawer = makeDrawer("[data-cart-drawer]", "[data-cart-open]", "[data-cart-close]");
    navDrawer = makeDrawer("[data-nav-drawer]", "[data-nav-open]", "[data-nav-close]");
    initNav();

    if (scrim) {
      scrim.addEventListener("click", function () {
        if (cartDrawer && cartDrawer.isOpen()) cartDrawer.toggle(false);
        if (navDrawer && navDrawer.isOpen()) navDrawer.toggle(false);
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (navDrawer && navDrawer.isOpen()) {
        if (panes.stack.length > 1) { panes.stack.pop(); paintPanes(); }
        else navDrawer.toggle(false);
        return;
      }
      if (cartDrawer && cartDrawer.isOpen()) cartDrawer.toggle(false);
    });

    initMega();
    montage.init();
    initProduct();
    initHero();
    initFilters();
    initReveals();
    initCardSliders();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Shopify-Theme-Editor: beim Einfuegen, Umsortieren oder Aendern einer Section
  // feuert kein DOMContentLoaded. Ohne diese Bruecke bliebe der neue Baustein
  // ohne Steuerung, bis jemand die Seite neu laedt.
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:reorder", boot);
})();
